import { AgencyApi } from '@/api';
export const LOCAL_STORAGE_PREPLAN_KEY = 'PreplanFields' as const;

export type ShowIfCondition = {
  field: string;
  eq: unknown;
};

export type ShowIfGroup = {
  AND?: (ShowIfGroup | ShowIfCondition)[];
  OR?: (ShowIfGroup | ShowIfCondition)[];
};

export type ShowIf = ShowIfCondition | ShowIfGroup | undefined;
export function evaluateShowIf(
  showIf: ShowIf,
  values: Record<string, any>,
): boolean {
  if (!showIf) return true;
  if ('field' in showIf) {
    const { field, eq } = showIf;
    const fieldValue = field
      .split('.')
      .reduce(
        (acc: typeof values, key: keyof typeof values) => acc?.[key],
        values,
      );
    return String(fieldValue) === String(eq);
  }

  if (showIf.AND) {
    const showAllIf = showIf.AND.every((c: any) =>
      evaluateShowIf(c as any, values),
    );
    return showAllIf;
  }
  if (showIf.OR) {
    return showIf.OR.some((c: any) => evaluateShowIf(c as any, values));
  }

  return true;
}

export const loadFormFields = async () => {
  const formFields = await AgencyApi.getPrePlanForm();
  if (formFields?.data) {
    localStorage.setItem(
      LOCAL_STORAGE_PREPLAN_KEY,
      JSON.stringify(formFields?.data),
    );
    return formFields.data;
  }
  return undefined;
};

export const getFormFields = () => {
  if (!localStorage.getItem(LOCAL_STORAGE_PREPLAN_KEY)) {
    loadFormFields();
  }
  const prePlanFields = localStorage.getItem(LOCAL_STORAGE_PREPLAN_KEY);
  if (prePlanFields) {
    return JSON.parse(prePlanFields);
  }
};
